// extracted by mini-css-extract-plugin
module.exports = {"button":"mobile-backbutton-module--button--dpdUH","buttonText":"mobile-backbutton-module--button-text--3WFBd"};